module.exports = __WEBPACK_EXTERNAL_MODULE_chart_js_auto_c730fedb__;